// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1j1cr","item":"styles_item__3K6WH","AppContent":"styles_AppContent__2kPFv","App__content":"styles_App__content__2Iqnw"};